import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function ExamResultFileListNoRowsOverlay() {
  return <NoRowsOverlay title='ยังไม่มีข้อมูลรายการไฟล์ผลการสอบ' icon={DescriptionOutlinedIcon} />;
}
